<template>
  <div>
    <p class="has-text-weight-bold is-size-4 mb-2">
      {{ $t("af:preliminary.psd2_sync.title") }}
    </p>

    <p class="has-text-grey-icon">
      {{ $t("af:preliminary.psd2_sync.subtitle") }}
    </p>

    <Psd2Field
      class="mt-5"
      :label="$t('af:preliminary.psd2_sync.field.title')"
      :description="$t('af:preliminary.psd2_sync.field.description')"
      :skippable="true"
      :source="PSD2_FIELD_SOURCE.PRELIM"
      @skip="onPsd2Skip"
    >
      <div class="psd2-sync-tooltip has-text-weight-bold is-flex">
        <b-icon icon="exclamation-circle" />
        <span class="ml-2">
          {{ $t("af:preliminary.psd2_sync.field.content.tooltip") }}
        </span>
      </div>

      <div class="is-flex mt-5">
        <b-icon icon="user-lock" class="is-blue-icon" size="is-large" />

        <div class="ml-4 is-flex is-flex-direction-column">
          <span class="has-text-weight-bold">
            {{ $t("af:preliminary.psd2_sync.field.content.security.title") }}
          </span>

          <span>
            {{
              $t("af:preliminary.psd2_sync.field.content.security.description")
            }}
          </span>
        </div>
      </div>
    </Psd2Field>
  </div>
</template>

<script>
import Psd2Field from "../psd2/Psd2Field";
import { PSD2_FIELD_SOURCE } from "../../utils/const";
import { mapMutations } from "vuex";

export default {
  name: "PreliminaryPsd2Sync",
  components: {
    Psd2Field,
  },
  props: {},
  data() {
    return {
      PSD2_FIELD_SOURCE,
    };
  },
  async created() {},
  methods: {
    ...mapMutations({
      previousStep: "preliminaryAssessment/previousStep",
    }),
    onPsd2Skip() {
      this.previousStep();
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/colors.scss";

.psd2-sync-tooltip {
  background-color: $grey-lightest;
  padding: 0.5rem;
  border-radius: 10px;
}
</style>
